export enum Color {
    Primary = 'Primary',
    Secondary = 'Secondary',
    Success = 'Success',
    Danger = 'Danger',
    Default = 'Default',
    White = 'White',
    Neutral = 'Neutral',
    Disabled = 'Disabled',
    DefaultButtonContainer = 'DefaultButtonContainer',
    PrimaryButtonContainer = 'PrimaryButtonContainer',
    DangerButtonContainer = 'DangerButtonContainer'
}